import(/* webpackMode: "eager", webpackExports: ["AppProviders"] */ "/repo/apps/backoffice/src/components/app-providers.tsx");
;
import(/* webpackMode: "eager" */ "/repo/node_modules/.pnpm/next@14.2.3_@opentelemetry+api@1.9.1_react-dom@18.3.1_react@18.3.1__react@18.3.1/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.tsx\",\"import\":\"Inter\",\"arguments\":[{\"subsets\":[\"latin\"],\"variable\":\"--font-sans\",\"display\":\"swap\"}],\"variableName\":\"inter\"}");
;
import(/* webpackMode: "eager" */ "/repo/apps/backoffice/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["Avatar","AvatarImage","AvatarFallback"] */ "/repo/packages/ui/src/components/avatar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["BackButton"] */ "/repo/packages/ui/src/components/back-button.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Calendar"] */ "/repo/packages/ui/src/components/calendar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Checkbox"] */ "/repo/packages/ui/src/components/checkbox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ClientTelemetryProvider","TelemetryUser","trackClientException","trackClientEvent","setTelemetryUser","flushClientTelemetry","isClientTelemetryReady"] */ "/repo/packages/ui/src/components/client-telemetry.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Combobox","MultiCombobox"] */ "/repo/packages/ui/src/components/combobox.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Command","CommandDialog","CommandInput","CommandList","CommandEmpty","CommandGroup","CommandItem","CommandSeparator"] */ "/repo/packages/ui/src/components/command.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ConfirmProvider","useConfirm"] */ "/repo/packages/ui/src/components/confirm-dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DatePicker"] */ "/repo/packages/ui/src/components/date-picker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DateTimePicker"] */ "/repo/packages/ui/src/components/date-time-picker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Dialog","DialogPortal","DialogOverlay","DialogClose","DialogTrigger","DialogContent","DialogHeader","DialogFooter","DialogTitle","DialogDescription"] */ "/repo/packages/ui/src/components/dialog.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DocumentActions"] */ "/repo/packages/ui/src/components/document-actions.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["DropdownMenu","DropdownMenuTrigger","DropdownMenuContent","DropdownMenuItem","DropdownMenuCheckboxItem","DropdownMenuRadioItem","DropdownMenuLabel","DropdownMenuSeparator","DropdownMenuShortcut","DropdownMenuGroup","DropdownMenuPortal","DropdownMenuSub","DropdownMenuSubContent","DropdownMenuSubTrigger","DropdownMenuRadioGroup"] */ "/repo/packages/ui/src/components/dropdown-menu.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["FilterBar"] */ "/repo/packages/ui/src/components/filter-bar.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MijnHandtekeningKaart"] */ "/repo/packages/ui/src/components/handtekening/mijn-handtekening-kaart.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["OndertekenPaneel"] */ "/repo/packages/ui/src/components/handtekening/onderteken-paneel.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignaturePadMetOpgeslagen"] */ "/repo/packages/ui/src/components/handtekening/signature-pad-met-opgeslagen.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["HistoryIndexTracker"] */ "/repo/packages/ui/src/components/history-index-tracker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Label"] */ "/repo/packages/ui/src/components/label.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LeverwijzeKiezer","LEVERWIJZE_KIEZER_DEFAULT_LABELS"] */ "/repo/packages/ui/src/components/leverwijze-kiezer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["LocatiePicker"] */ "/repo/packages/ui/src/components/locatie-picker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MiddelFormulier"] */ "/repo/packages/ui/src/components/middel-formulier.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultiDatePicker"] */ "/repo/packages/ui/src/components/multi-date-picker.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["MultiPhotoUpload"] */ "/repo/packages/ui/src/components/multi-photo-upload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PageError"] */ "/repo/packages/ui/src/components/page-error.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Pagination","DEFAULT_PAGINATION_LABELS","resolvePaginationLabels","paginationState","resolveTotalPages","clampPage","parsePageInput","buildPageHref","pageOptions","MOBILE_SELECT_MAX","LAZY_OPTIONS_THRESHOLD"] */ "/repo/packages/ui/src/components/pagination.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PdfPreviewModal"] */ "/repo/packages/ui/src/components/pdf-preview-modal.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PhotoUpload"] */ "/repo/packages/ui/src/components/photo-upload.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["PlanningLegend"] */ "/repo/packages/ui/src/components/planning-legend.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Popover","PopoverTrigger","PopoverContent","PopoverAnchor"] */ "/repo/packages/ui/src/components/popover.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ThemaBanner"] */ "/repo/packages/ui/src/components/portal-thema/thema-banner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ProfielSlide"] */ "/repo/packages/ui/src/components/profiel-slide.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RadioGroup","RadioGroupItem"] */ "/repo/packages/ui/src/components/radio-group.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ResponsiveTable","DataList"] */ "/repo/packages/ui/src/components/responsive-table.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["RotatiePatroonEditor","RotatiePatroonStrip","DAG_CODE_KLEUR","DAY_CODE_ORDER"] */ "/repo/packages/ui/src/components/rotatie-patroon-editor.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["QrScanner"] */ "/repo/packages/ui/src/components/scanner/qr-scanner.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ScanInvoer","useHandscanner"] */ "/repo/packages/ui/src/components/scanner/scan-invoer.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useQrCamera"] */ "/repo/packages/ui/src/components/scanner/use-qr-camera.ts");
;
import(/* webpackMode: "eager", webpackExports: ["Select","SelectGroup","SelectValue","SelectTrigger","SelectContent","SelectLabel","SelectItem","SelectSeparator","SelectScrollUpButton","SelectScrollDownButton"] */ "/repo/packages/ui/src/components/select.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Separator"] */ "/repo/packages/ui/src/components/separator.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Sheet","SheetPortal","SheetOverlay","SheetTrigger","SheetClose","SheetContent","SheetHeader","SheetFooter","SheetTitle","SheetDescription"] */ "/repo/packages/ui/src/components/sheet.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SignaturePad"] */ "/repo/packages/ui/src/components/signature-pad.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["SwipeActie"] */ "/repo/packages/ui/src/components/swipe-actie.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Switch"] */ "/repo/packages/ui/src/components/switch.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Tabs","TabsList","TabsTrigger","TabsContent"] */ "/repo/packages/ui/src/components/tabs.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["ToastProvider","ToastViewport","Toast","ToastTitle","ToastDescription","ToastClose","ToastAction","toastVariants"] */ "/repo/packages/ui/src/components/toast.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["Toaster"] */ "/repo/packages/ui/src/components/toaster.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["WeekStatusBadge","WeekStatusLegenda","onderhoudWeekKleur","dekkingWeekKleur","weekStatusTekst","WEEK_STATUS_UITLEG"] */ "/repo/packages/ui/src/components/week-status-badge.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["useReloadOnChunkError","isChunkLoadError","chunkPadUitFout"] */ "/repo/packages/ui/src/hooks/use-reload-on-chunk-error.ts");
;
import(/* webpackMode: "eager", webpackExports: ["useToast","toast"] */ "/repo/packages/ui/src/hooks/use-toast.ts");
